/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-23 12:01:29
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-04-23 15:28:22
 */

/**
 * AiProcessingOverlay 组件
 *
 * 功能：AI处理覆盖层，显示照片处理状态
 * 包含：
 * - 处理中加载状态展示
 * - 取消处理选项
 * - 处理失败提示
 * - 重试功能
 */
import React from 'react'
import { Spin, Button } from 'antd'
import {
  CloseCircleOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'

interface AiProcessingOverlayProps {
  aiProcessing: boolean
  aiProcessingFailed: boolean
  onCancelAiClear: () => void
  onFailureConfirm: () => void
  onRetry: () => void
}

const AiProcessingOverlay: React.FC<AiProcessingOverlayProps> = ({
  aiProcessing,
  aiProcessingFailed,
  onCancelAiClear,
  onFailureConfirm,
  onRetry
}) => {
  if (!aiProcessing && !aiProcessingFailed) {
    return null
  }

  // 添加样式函数，确保样式已经被添加
  const ensureStyleExists = () => {
    const styleId = 'ai-processing-modal-style'
    if (document.getElementById(styleId)) return

    const styles = `
      .ai-processing-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .ai-processing-modal .close-btn {
        position: absolute;
        top: 10px;
        right: 30px;
        cursor: pointer;
        color: white;
        font-size: 28px;
      }
      .ai-processing-modal .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: transparent !important;
      }
      .ai-processing-modal .logo {
        width: 120px;
        height: 120px;
        margin-bottom: 20px;
      }
      .ai-processing-modal .text {
        font-size: 22px;
        color: white;
        margin-bottom: 5px;
      }
      .fail-process-model .content{
        width: 416px;
        height: 136px;
        background-color: #ffffff !important;
        display: block !important;
        padding: 30px;
      }
      .fail-process-model .text{
        color: #000000;
        font-size: 17px
      }
    `

    const aiModalStyle = document.createElement('style')
    aiModalStyle.id = styleId
    aiModalStyle.type = 'text/css'
    aiModalStyle.appendChild(document.createTextNode(styles))
    document.head.appendChild(aiModalStyle)
  }

  ensureStyleExists()

  return (
    <>
      {aiProcessing && (
        <div className="ai-processing-modal">
          <div className="close-btn" onClick={onCancelAiClear}>
            <CloseCircleOutlined
              style={{
                marginRight: '5px',
                color: '#ffffff',
                fontSize: '21px'
              }}
            />
            <span
              style={{
                fontSize: '16px',
                lineHeight: '22px',
                color: '#ffffff',
                verticalAlign: 'middle'
              }}
            >
              取消生成
            </span>
          </div>

          <div className="content">
            <div style={{ marginBottom: 20 }}>
              <Spin size="large" />
            </div>
            <p className="text">正在生成...</p>
          </div>
        </div>
      )}

      {aiProcessingFailed && (
        <div className="ai-processing-modal fail-process-model">
          <div className="content">
            <div style={{ display: 'flex' }}>
              <ExclamationCircleOutlined
                style={{
                  fontSize: '22px',
                  color: '#1890FF',
                  marginRight: '10px'
                }}
              />
              <p className="text">照片变清晰失败，请重试</p>
            </div>
            <div
              style={{
                marginTop: '20px',
                display: 'flex',
                gap: '10px',
                justifyContent: 'end'
              }}
            >
              <Button onClick={onFailureConfirm} style={{ width: '88px' }}>
                我知道了
              </Button>
              <Button
                type="primary"
                onClick={onRetry}
                style={{ width: '60px' }}
              >
                重试
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default AiProcessingOverlay
